import apiClient from 'helpers/axios';
import { AUTHN, USERS_ME_SINGLEUSETOKENS, CONFIRMEMAIL, COMPLETESETUP } from 'constants/apis';
import { TokenTypes } from './tokens';

export const init = () => {
  const jwt = window.localStorage.getItem('global-opportunities-jwt');
  if (jwt) {
    apiClient.defaults.headers.common.Authorization = `Bearer ${jwt}`;
  }
};

export const login = async (email, password) => {
  const { data } = await apiClient.post(AUTHN, {
    email,
    password,
  });

  if (data.jwt) {
    window.localStorage.setItem('global-opportunities-jwt', data.jwt);
    apiClient.defaults.headers.common.Authorization = `Bearer ${data.jwt}`;
  }

  return data;
};

export const logout = () => {
  window.localStorage.removeItem('global-opportunities-jwt');
  delete apiClient.defaults.headers.common.Authorization;
};

export const register = (token, { firstName, lastName, password }) => {
  return apiClient.post(COMPLETESETUP, { token, firstName, lastName, password });
};

export const confirmAccount = async token => {
  await apiClient.post(CONFIRMEMAIL, { token });
  return true;
};

export const sendAccountConfirmationEmail = () => {
  return apiClient.post(USERS_ME_SINGLEUSETOKENS, null, {
    params: {
      type: TokenTypes.CONFIRM_EMAIL,
    },
  });
};
